import {SET_ERROR, NEW_SALES_SUCCESS,UPDATE_SALES_SUCCESS} from "./actionTypes";

export const newSales = (response , client_id,trip_id) => {
    console.group('newSales');
    console.log(response);
    console.log(client_id);
    console.log(trip_id);
    console.groupEnd();
    if(!response || Object.keys(response).length === 0){
        console.error('newSales','no sales data provided');
        return {
            type: SET_ERROR,
            error: 'no sales data provided'
        };
    }
    if(!client_id){
        console.error('newSales','no client id provided');
        return {
            type: SET_ERROR,
            error: 'no client id provided'
        };
    }
    if(!trip_id){
        console.error('newSales','no trip id provided');
        return {
            type: SET_ERROR,
            error: 'no trip id provided'
        };
    }
    return {
        type: NEW_SALES_SUCCESS,
        sales_data: response,
        client_id: client_id,
        trip_id:trip_id
    };
}

export const updateSales = (response , client_id,trip_id, sales_id) => {
    console.group('updateSales');
    console.log(response);
    console.log(client_id);
    console.log(trip_id);
    console.log(sales_id);
    console.groupEnd();
    if(!response || Object.keys(response).length === 0){
        console.error('updateSales','no sales data provided');
        return {
            type: SET_ERROR,
            error: 'no sales data provided'
        };
    }
    if(!client_id){
        console.error('updateSales','no client id provided');
        return {
            type: SET_ERROR,
            error: 'no client id provided'
        };
    }
    if(!trip_id){
        console.error('updateSales','no trip id provided');
        return {
            type: SET_ERROR,
            error: 'no trip id provided'
        };
    }
    if(sales_id === '' || sales_id === undefined){
        console.error('updateSales','no sales id provided');
        return {
            type: SET_ERROR,
            error: 'no catch id provided'
        };
    }
    return {
        type: UPDATE_SALES_SUCCESS,
        sales_data: response,
        client_id: client_id,
        trip_id:trip_id,
        sales_id:sales_id
    };
}
